export default {
  creatOrderData: '/gateway/capp/mallcenter/PropSaleForAppRpcService/createOrder',
  getCreatOrderData: '/gateway/capp/mallcenter/PropSaleForAppRpcService/preCreateOrder',
  getPayAgentList: '/payment/getPayAgentList',

  getLevelInfo: '/gateway/capp/mallcenter/PropSaleForAppRpcService/getLevelInfo',
  getGloryInfo: '/gateway/capp/mallcenter/PropSaleForAppRpcService/getGloryInfo',
  getMemberInfo: '/gateway/capp/mallcenter/PropSaleForAppRpcService/getMemberInfo'
}
